import { Reducer } from 'redux';
import { IOpenNewTemplateState, IOpenNewTemplateAction } from './types';

const initialState = {
  openNewTemplate: false
}

const OpenNewTemplateReducer: Reducer<IOpenNewTemplateState> = ((state:IOpenNewTemplateState = initialState, action) => {
  switch((action as IOpenNewTemplateAction).type) {
    case "OPEN_NEW_TEMPLATE": {
      return { ...state, openNewTemplate: action.payload}
    }
    default:
      return state
  }
});

export default OpenNewTemplateReducer;
